var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c3-custom-chart" }, [
    _c("div", { ref: _vm.chartIdString, attrs: { id: _vm.chartIdString } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }